export interface CustomerAddressDisplay {
  first_name?: string;
  last_name?: string;
  company?: string;
  street_1?: string;
  street_2?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  phone?: string;
  address_type?: string;
}

function asLine(value: string | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

/**
 * Present a BigCommerce address_type ("residential", "commercial") as a display label.
 */
export function formatAddressType(addressType: string | undefined): string {
  const trimmed = addressType?.trim();
  if (!trimmed) {
    return '';
  }
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
}

/**
 * Build display lines for a customer address (name, street, city/state/zip, country).
 */
export function formatCustomerAddressLines(address: CustomerAddressDisplay): string[] {
  const lines: string[] = [];
  const name = [asLine(address.first_name), asLine(address.last_name)].filter(Boolean).join(' ');
  if (name) {
    lines.push(name);
  }

  const company = asLine(address.company);
  if (company) {
    lines.push(company);
  }

  const street1 = asLine(address.street_1);
  if (street1) {
    lines.push(street1);
  }

  const street2 = asLine(address.street_2);
  if (street2) {
    lines.push(street2);
  }

  const cityStateZip = [asLine(address.city), asLine(address.state), asLine(address.zip)]
    .filter(Boolean)
    .join(', ');
  if (cityStateZip) {
    lines.push(cityStateZip);
  }

  const country = asLine(address.country);
  if (country) {
    lines.push(country);
  }

  const phone = asLine(address.phone);
  if (phone) {
    lines.push(phone);
  }

  return lines;
}
